import { Component, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { map } from 'rxjs/operators';

import notify from 'devextreme/ui/notify';
import { DxDataGridComponent, DxContextMenuComponent, DxPivotGridComponent } from 'devextreme-angular';

import { GridService, MessageService } from 'kmm-corp-api';

import { ModeloGridFormComponent } from '../form/modelo-grid.form';

@Component({
   selector: 'app-modelo-grid-lista-component',
   templateUrl: './modelo-grid.lista.html'
})
export class ModeloGridListaComponent {

   @ViewChild('modeloGridForm', { static: true }) modeloGridForm: ModeloGridFormComponent;
   @ViewChild('contextMenu', { static: true }) contextMenu: DxContextMenuComponent;

   private _toolbar: any;

   @Input() dxDataGrid: DxDataGridComponent;
   @Input() dxPivotGrid: DxPivotGridComponent;
   @Input() contextName: string;

   @Output() modeloChange: EventEmitter<any> = new EventEmitter();

   visible: boolean = false;
   modelos: any = [];

   optionItems: any = [
      { text: 'Aplicar modelo', icon: 'fas fa-level-down-alt', onItemClick: this.aplicarModelo },
      { text: 'Definir como padrÃ£o', icon: 'fas fa-level-up-alt', onItemClick: this.definirPadrao },
      { text: 'Substituir pelas configuraÃ§Ãµes atuais', icon: 'fas fa-retweet', onItemClick: this.substituirModelo },
      { text: 'Excluir modelo', icon: 'fas fa-trash-alt', onItemClick: this.delModelo }
   ];

   constructor(
      protected _gridService: GridService,
      protected _messageService: MessageService
   ) {
   }

   contextShowing(ev, row) {
      const dataSource = ev.component.option('items');

      dataSource.forEach(item => {
         Object.assign(item, {
            context: this,
            row: row
         });
      });

      ev.component.option('items', dataSource);
   }

   optionClicked(ev) {
      const data = ev.itemData;

      data.onItemClick(ev);
   }

   aplicarModelo(ev) {
      const context: ModeloGridListaComponent = ev.itemData.context;

      console.log(ev.itemData.row.colunas);

      const state = JSON.parse(ev.itemData.row.colunas);

      if (context.dxDataGrid) {
         context.dxDataGrid.instance.state(state);
      }

      if (context.dxPivotGrid) {
         context.dxPivotGrid.instance.getDataSource().state(state);
      }

      context.modeloChange.emit(ev.itemData.row);
   }

   definirPadrao(ev) {
      const context: ModeloGridListaComponent = ev.itemData.context;
      const modelo = ev.itemData.row;
      Object.assign(modelo, {
         padrao: true
      });

      context._gridService.altModelo(modelo).subscribe(res => {
         notify({ message: res.mensagem, type: 'success', displayTime: 5000, closeOnClick: true });

         context.onShown(null);
      });
   }

   substituirModelo(ev) {
      const context = ev.itemData.context;
      const modelo = ev.itemData.row;

      let gridState;

      if ('dxDataGrid' in context) {
         gridState = context.dxDataGrid.instance.state();
      } else if ('dxPivotGrid in context') {
         gridState = context.dxPivotGrid.instance.getDataSource().state();
      }

      // if ('grid' in context._gridService.gridContext[modelo.grid_ref]) {
      //    if ('dxDataGrid' in context._gridService.gridContext[modelo.grid_ref].grid) {
      //       gridState = context._gridService.gridContext[modelo.grid_ref].grid.dxDataGrid.instance.state();
      //    } else if ('dxPivotGrid' in context._gridService.gridContext[modelo.grid_ref].grid) {
      //       gridState = context._gridService.gridContext[modelo.grid_ref].grid.dxPivotGrid.instance.getDataSource().state();
      //    }
      // } else {
      //    if ('dxDataGrid' in context._gridService.gridContext[modelo.grid_ref]) {
      //       gridState = context._gridService.gridContext[modelo.grid_ref].dxDataGrid.instance.state();
      //    } else if ('dxPivotGrid' in context._gridService.gridContext[modelo.grid_ref]) {
      //       gridState = context._gridService.gridContext[modelo.grid_ref].dxPivotGrid.instance.getDataSource().state();
      //    }
      // }

      if (gridState) {
         Object.assign(modelo, {
            colunas: JSON.stringify(gridState)
         });

         context._gridService.altModelo(modelo).subscribe(res => {
            notify({ message: res.mensagem, type: 'success', displayTime: 5000, closeOnClick: true });

            context.onShown(null);
         });
      }
   }

   delModelo(ev) {
      const context: ModeloGridListaComponent = ev.itemData.context;

      context._gridService.delModelo(ev.itemData.row).subscribe(res => {
         notify({ message: res.mensagem, type: 'success', displayTime: 5000, closeOnClick: true });

         context.onShown(null);
      });
   }

   onHidden(ev) {
      this.visible = false;
   }

   onShown(ev) {
      this._gridService.getModelos({ grid_ref: this.contextName }).pipe(
         map(result => {
            result.forEach(item => {
               Object.assign(item, {
                  descricao: item.descricao.toUpperCase()
               });
            });

            return result;
         }))
         .subscribe(data => {
            this.modelos = data;
         });
   }

   toggleNewModeloPopup() {
      this.modeloGridForm.visible = true;
   }

   refreshGrid(ev) {
      this.onShown(null);

      if (ev.padrao) {
         this.modeloChange.emit(ev);
      }
   }

   onToolbarPreparing(event) {
      const toolbarItems = event.toolbarOptions.items;

      const defaultItems = [
         {
            location: 'before',
            widget: 'dxButton',
            options: {
               icon: 'refresh',
               hint: 'Atualizar',
               elementAttr: {
                  id: 'atualizar'
               },
               onClick: () => this.onShown(null)
            }
         },
         {
            location: 'before',
            widget: 'dxButton',
            options: {
               icon: 'floppy',
               hint: 'Criar Modelo',
               elementAttr: {
                  id: 'modelo'
               },
               onClick: () => this.toggleNewModeloPopup()
            }
         }
      ];

      let items = defaultItems.concat(this.toolbar);

      if (this.toolbar) {
         items = defaultItems.concat(this.toolbar);
      } else {
         items = defaultItems;
      }

      items.forEach(item => {
         toolbarItems.push(item);
      });
   }

   set toolbar(toolbar: any) {
      this._toolbar = toolbar;
   }

   get toolbar(): any {
      return this._toolbar;
   }

}
